<mat-form-field>
    <mat-select [formControl]="control" name="role" [disabled]="canEdit === false">
        <mat-option *ngFor="let role of roles" [value]="role">
            {{ role.label }}
        </mat-option>
    </mat-select>
</mat-form-field>